module.exports = __webpack_public_path__ + "static/media/administration.fd8c9da0.png";